<template>
  <div
    class="prompt cr-flex cr-br-medium gap-2 cr-align-center"
    @click="$emit('prompt-clicked', text)"
  >
    <div class="prompt__icon-container cr-flex cr-align-center cr-justify-center cr-br-small">
      {{ emoji }}
    </div>
    <div class="cr-flex cr-align-center">
      <span class="prompt__text label-m-regular">
        {{ text }}
      </span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ClientHomePageStarterPrompt',
  props: {
    emoji: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  emits: ['prompt-clicked'],
}
</script>

<style lang="scss" scoped>
.prompt {
  border: 1px solid var(--candy-wrapper-500);
  padding: 5px;
  cursor: pointer;

  &:hover {
    border-color: var(--candy-wrapper-1000);
    background-color: var(--candy-wrapper-200);
    box-shadow: 0px 2px 2px 1px #00000005;
  }

  &:active {
    background-color: var(--candy-wrapper-300);
  }

  &__icon-container {
    width: 32px;
    min-width: 32px;
    height: 32px;
    max-height: 32px;
    background-color: var(--candy-wrapper-100);
  }

  &__text {
    text-align: start;
  }
}
</style>
